/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EnhancedConfigurationDto } from './EnhancedConfigurationDto';
import {
    EnhancedConfigurationDtoFromJSON,
    EnhancedConfigurationDtoFromJSONTyped,
    EnhancedConfigurationDtoToJSON,
    EnhancedConfigurationDtoToJSONTyped,
} from './EnhancedConfigurationDto';

/**
 * 
 * @export
 * @interface EnhancedConfigurationResponse
 */
export interface EnhancedConfigurationResponse {
    /**
     * 
     * @type {EnhancedConfigurationDto}
     * @memberof EnhancedConfigurationResponse
     */
    data?: EnhancedConfigurationDto;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof EnhancedConfigurationResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof EnhancedConfigurationResponse
     */
    error?: string;
}

/**
 * Check if a given object implements the EnhancedConfigurationResponse interface.
 */
export function instanceOfEnhancedConfigurationResponse(value: object): value is EnhancedConfigurationResponse {
    return true;
}

export function EnhancedConfigurationResponseFromJSON(json: any): EnhancedConfigurationResponse {
    return EnhancedConfigurationResponseFromJSONTyped(json, false);
}

export function EnhancedConfigurationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnhancedConfigurationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : EnhancedConfigurationDtoFromJSON(json['data']),
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function EnhancedConfigurationResponseToJSON(json: any): EnhancedConfigurationResponse {
    return EnhancedConfigurationResponseToJSONTyped(json, false);
}

export function EnhancedConfigurationResponseToJSONTyped(value?: EnhancedConfigurationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': EnhancedConfigurationDtoToJSON(value['data']),
        'success': value['success'],
        'error': value['error'],
    };
}

